import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { Button, Card, Dropdown, Menu, message } from 'antd';
import { mutations, queries } from '../../graphql/graphql';
import axios from 'axios';

import { Specifications } from '../Specifications';

const TemplateUpdate = props => {
  const { params } = props.match;
  const { loading, data = {} } = useQuery(queries.TEMPLATE, { variables: { id: params.id } });

  const [items, setItems] = useState([]);
  const [typeform, setTypeform] = useState({});
  const [isSubmitting] = useState(false);

  const [contractorSpec, setContractorSpec] = useState([]);
  const [planSpec, setPlanSpec] = useState([]);

  useEffect(() => {
    axios({
      method: 'get',
      url: '/api/typeform/forms'
    }).then(function(response) {
      if (response.status === 200) {
        setItems(response.data);
        if (!loading && data) {
          const { template } = data;
          const { typeformId, specifications } = template;
          const typeformItem = response.data.find(d => d.id === typeformId);
          if (typeformItem) {
            setTypeform(typeformItem);
          }
          if (specifications && specifications.contractor) {
            setContractorSpec(specifications.contractor);
          }
          if (specifications && specifications.plan) {
            setPlanSpec(specifications.plan);
          }
        }
      } else {
        console.log(response);
      }
    });
  }, [data]);

  const selectTypeform = item => {
    setTypeform(item);
  };

  const menu = items.map(item => (
    <Menu.Item key={item.id} onClick={() => selectTypeform(item)}>
      {item.title}
    </Menu.Item>
  ));

  const [TEMPLATE_UPDATE] = useMutation(mutations.TEMPLATE_UPDATE);

  const saveTemplate = () => {
    const { id, title, _links } = typeform;
    const specifications = { contractor: contractorSpec, plan: planSpec };

    TEMPLATE_UPDATE({
      variables: { id: params.id, typeformId: id, title, link: _links.display, specifications }
    }).then(
      res => {
        message.success('Template successfully updated');
        console.log(res);
      },
      err => {
        console.log(err);
      }
    );
  };

  return (
    <div
      style={{
        display: 'block',
        width: '100vw',
        height: '100vh',
        padding: 0,
        background: '#ffffff'
      }}
    >
      <div style={{ margin: '1em' }}>
        <Dropdown
          overlay={<Menu style={{ scroll: 'auto' }}>{menu}</Menu>}
          placement="bottomLeft"
          arrow
        >
          <Button>Select typeform</Button>
        </Dropdown>
      </div>
      {typeform && typeform.id && (
        <div style={{ margin: '1em' }}>
          <Card style={{ margin: '1em' }}>
            <Card.Meta title={typeform.title} description={typeform.last_updated_at} />
            <br />
            Public: {typeform.settings.is_public ? 'Yes' : 'No'}
            <br />
            <a href={typeform._links.display}>link</a>
          </Card>
          <Card style={{ margin: '1em' }}>
            <Card.Meta title="Select questions for Contractors" />
            <br />
            <Specifications
              onChange={setContractorSpec}
              value={contractorSpec}
              typeform={{ typeformId: typeform.id }}
            />
          </Card>
          <Card style={{ margin: '1em' }}>
            <Card.Meta title="Select questions for Plans" />
            <br />
            <Specifications
              onChange={setPlanSpec}
              value={planSpec}
              typeform={{ typeformId: typeform.id }}
            />
          </Card>
          <Button type="primary" loading={isSubmitting} onClick={() => saveTemplate()}>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

TemplateUpdate.propTypes = {
  user: PropTypes.object.isRequired
};

const connectedUpdate = connect(mapStateToProps, mapDispatchToProps)(TemplateUpdate);

export default connectedUpdate;
